document.addEventListener("DOMContentLoaded", function () {
  // Seleccionamos el elemento a observar
  const priceWas = document.querySelector(".price__was");
  const priceDiscount = document.querySelector(".price__discount");

  if (priceDiscount) {
    // Creamos una instancia de MutationObserver
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class") {
          // Verificamos si el elemento tiene la clase 'hidden'
          if (priceWas?.classList.contains("hidden")) {
            priceDiscount.style.display = "none";
          } else {
            priceDiscount.style.display = "inline";
          }
        }
      });
    });
    // Configuramos el observer para observar cambios en los atributos del elemento
    if (priceWas) observer.observe(priceWas, { attributes: true });

    // Verificamos el estado inicial del elemento
    if (priceWas?.classList.contains("hidden")) {
      priceDiscount.style.display = "none";
    } else {
      priceDiscount.style.display = "inline";
    }
  }
});
